import React from 'react';
import { RevenueDistribution } from '../RevenueDistribution/RevenueDistribution';
import { OvertimeAnalysis } from '../OvertimeAnalysis/OvertimeAnalysis';
import { ProductMetricDistribution } from '../ProductMetricDistribution/ProductMetricDistribution';
import { DeviceRevenueDistribution } from '../DeviceRevenueDistribution/DeviceRevenueDistribution';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { DeviceFilterEnum } from '../FilterSection/DeviceSelector/types';
import { TimeRangeEnum } from '../FilterSection/TimeRangeSelector/types';

const ChartCard = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: 12,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
}));

interface IChartsContainerProps {
  timeRange: TimeRangeEnum;
  product: string;
  device: DeviceFilterEnum;
  shopId: number;
}
export const ChartsContainer = ({ timeRange, product, device, shopId }: IChartsContainerProps) => {
  return (
    <Grid container spacing={2} alignItems='stretch' style={{ marginTop: '30px', width: '100%' }}>
      <Grid item xs={12} md={4} display={'flex'}>
        <ChartCard>
          <RevenueDistribution
            timeRange={timeRange}
            product={product}
            device={device}
            shopId={shopId}
          />
        </ChartCard>
      </Grid>

      <Grid item xs={12} md={8} display={'flex'}>
        <ChartCard>
          <OvertimeAnalysis
            timeRange={timeRange}
            product={product}
            device={device}
            shopId={shopId}
          />
        </ChartCard>
      </Grid>

      <Grid item xs={12} md={6} display={'flex'}>
        <ChartCard>
          <ProductMetricDistribution timeRange={timeRange} device={device} shopId={shopId} />
        </ChartCard>
      </Grid>

      <Grid item xs={12} md={6} display={'flex'}>
        <ChartCard>
          <DeviceRevenueDistribution timeRange={timeRange} product={product} shopId={shopId} />
        </ChartCard>
      </Grid>
    </Grid>
  );
};
